import React, { useEffect, useState } from "react";

const API_BASE_URL = "";

const escapeXml = (value) =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

const downloadExcel = (fileName, sheetName, headers, rows) => {
  const headerXml = `<Row>${headers
    .map(
      (header) =>
        `<Cell ss:StyleID="Header"><Data ss:Type="String">${escapeXml(
          header
        )}</Data></Cell>`
    )
    .join("")}</Row>`;

  const bodyXml = rows
    .map(
      (row) =>
        `<Row>${row
          .map(
            (cell) =>
              `<Cell><Data ss:Type="String">${escapeXml(cell)}</Data></Cell>`
          )
          .join("")}</Row>`
    )
    .join("");

  const xml = `<?xml version="1.0"?>
<?mso-application progid="Excel.Sheet"?>
<Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet"
 xmlns:o="urn:schemas-microsoft-com:office:office"
 xmlns:x="urn:schemas-microsoft-com:office:excel"
 xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet"
 xmlns:html="http://www.w3.org/TR/REC-html40">
 <Styles>
  <Style ss:ID="Header">
   <Font ss:Bold="1"/>
   <Interior ss:Color="#E5E7EB" ss:Pattern="Solid"/>
  </Style>
 </Styles>
 <Worksheet ss:Name="${escapeXml(sheetName.slice(0, 31))}">
  <Table>
   ${headerXml}
   ${bodyXml}
  </Table>
 </Worksheet>
</Workbook>`;

  const blob = new Blob([xml], {
    type: "application/vnd.ms-excel",
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${fileName}.xls`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

const formatDate = (value) => {
  if (!value) {
    return "";
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleString();
};

const Signups = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchSignups = async () => {
      try {
        setLoading(true);
        setError("");

        const token = localStorage.getItem("indiaboatsAdminToken");
        const response = await fetch(`${API_BASE_URL}/api/signup`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to load signups");
        }

        const result = await response.json();
        setRows(Array.isArray(result) ? result : []);
      } catch (fetchError) {
        console.error("Signups fetch error:", fetchError);
        setRows([]);
        setError(fetchError.message || "Failed to load signups");
      } finally {
        setLoading(false);
      }
    };

    fetchSignups();
  }, []);

  const handleDownloadExcel = () => {
    if (!rows.length) {
      alert("No signups to download.");
      return;
    }

    const headers = [
      "Name",
      "Email",
      "Mobile",
      "Company Name",
      "GST",
      "Address",
      "Reference",
      "Signed Up At",
    ];
    const excelRows = rows.map((row) => [
      row.name || "",
      row.email || "",
      row.mobile || "",
      row.companyName || "",
      row.gst || "",
      row.address || "",
      row.reference || "",
      formatDate(row.createdAt),
    ]);

    downloadExcel("signups", "Signups", headers, excelRows);
  };

  return (
    <div className="cms-page">
      <div className="cms-page-header">
        <div>
          <h1>Signups</h1>
          <p>
            Users who create an account on the website signup page appear here.
          </p>
        </div>

        <button
          type="button"
          className="cms-save-btn"
          onClick={handleDownloadExcel}
          disabled={loading || !rows.length}
        >
          Download Excel
        </button>
      </div>

      <div className="cms-packages-layout">
        <div className="cms-packages-main">
          <div className="cms-section-card">
            <div className="cms-section-card-header">
              <h2>Registered Users</h2>
              <p>
                {rows.length} {rows.length === 1 ? "signup" : "signups"} from
                the website form.
              </p>
            </div>

            {loading ? (
              <p className="cms-inquiries-empty">Loading signups...</p>
            ) : error ? (
              <p className="cms-inquiries-empty">{error}</p>
            ) : rows.length === 0 ? (
              <p className="cms-inquiries-empty">No signups yet.</p>
            ) : (
              <div className="cms-enquiries-table-wrap">
                <table className="cms-enquiries-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Mobile</th>
                      <th>Company Name</th>
                      <th>GST</th>
                      <th>Address</th>
                      <th>Reference</th>
                      <th>Signed Up At</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, index) => (
                      <tr key={row._id || index}>
                        <td>{index + 1}</td>
                        <td>{row.name}</td>
                        <td>{row.email}</td>
                        <td>{row.mobile}</td>
                        <td>{row.companyName || "—"}</td>
                        <td>{row.gst || "—"}</td>
                        <td>{row.address || "—"}</td>
                        <td>{row.reference || "—"}</td>
                        <td>{formatDate(row.createdAt)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signups;
